/**
 * CV Upload: step 1 of ATS analysis — upload PDF/Word, then go to analysis.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Seo from '../components/Seo';
import CVFileDropzone from '../components/CVFileDropzone';
import './FlowPages.css';

const CVUpload = () => {
  const { t } = useLanguage();

  return (
    <div className="container flow-page">
      <Seo title={t('flow.uploadTitle')} description={t('flow.uploadLead')} path="/dashboard/upload" noindex />
      <div className="flow-card">
        <Link to="/dashboard" className="flow-back">
          ← {t('dashboard.back')}
        </Link>
        <p className="flow-step">{t('flow.stepOf', { current: 1, total: 2 })}</p>
        <h1 className="flow-title">{t('flow.uploadTitle')}</h1>
        <p className="flow-lead">{t('flow.uploadLead')}</p>
        <CVFileDropzone source="ats" />
        <div className="flow-tip">
          <strong>{t('flow.tipTitle')}</strong>
          <ul>
            <li>{t('flow.tipSelectable')}</li>
            <li>{t('flow.tipLength')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CVUpload;
